<template>
  <div class="d-flex flex-column justify-content-center align-items-center col-md-12 router-view-report-background">
    <div class="col-md-12 px-0">
      <report-filters
        :creators="creators"
        @get-report="submitReport"
      />
      <div class="stat-cards">
        <presentation :total_production="computedTotalInterpolation"/>
      </div>
    </div>

    <div class="col-md-12 px-0">
      <the-table 
        id="interpolaiton-report"
        :dataItems="computedResults"
        :headers="headersForTable"
      >
        <template v-slot:animal_name="{item}">
          <span>{{item.animal.name}}</span>
        </template>
        <template v-slot:actions="{item}">
          <v-btn
            class="info"
            @click="openDetails(item)"
          >
            Detalhes
          </v-btn>
        </template>
      </the-table>
    </div>

    <sidebar 
      :animal="details" 
    />

    <button-export
      :print="true"
      @print="PDFPrint"
      v-if="computedResults.length"
      :excel="true"
      :data="computedExcel"
      :title="'Relatório de Interpolação'"
      @export-pdf="PDFExport"
    />
  </div>
</template>

<script>
import Presentation from "./Presentation";
import ReportFilters from "./ReportFilters";
import TheTable from "@/components/layout/TheTable";
import ButtonExport from "@/components/layout/ButtonExport";
import {mapState, mapActions, mapMutations} from "vuex";
import { exportOfficialTablePdf } from "@/utils/officialPdf";
export default {
  name:"InterpolationReport",
  components: {
    Presentation,
    ReportFilters,
    TheTable,
    ButtonExport,
    Sidebar: () => import("./SidebarInterpolation")
  },
  data() {
    return {
      headersForTable:[
        {text:"Animal", value:"animal_name", sortable:true, has_slot:true},
        {text:"Data Último Parto", value:"last_birthday", sortable:true},
        {text:"1º Controle", value:"first_weight", sortable:true},
        {text:"Controles", value:"count_weights", sortable:true},
        {text:"Produção", value:"total_milk_production", sortable:true},
        {text:"", value:"actions", has_slot:true}
      ],
      details:{},
      filter:{}
    }
  },
  computed: {
    ...mapState("creators", ["creators"]),
    ...mapState("interpolation_report", ["results"]),
    computedTotalInterpolation() {
      if(this.results.length) {
        return this.results.map(e => {return e.total_milk_production}).reduce((previousValue, currentValue) => previousValue + currentValue);
      } else {
        return 0;
      }
    },
    computedResults() {
      return this.results;
    },
    computedExcel() {
       if(this.computedResults.length) {
        return this.computedResults.map(e => ({
          Animal:e.animal.name,
          "Data do Último Parto":e.last_birthday,
          "1º Controle":e.first_weight,
          "Controles":e.count_weights,
          "Produção":e.total_milk_production
        }));
      } else {
        return [];
      } 
    }
  },
  methods: {
    ...mapActions("creators", ["actionGetCreators"]),
    ...mapActions("interpolation_report", ["actionGetInterpolationReport"]),
    ...mapMutations("sidebar", ["SET_ACTIVE"]),
    async submitReport(filter) {
      this.filter = filter;
      await this.actionGetInterpolationReport(filter.animals.filter(e => e !== undefined));
    },
    openDetails(item) {
      this.details = item; 
      this.SET_ACTIVE(true);
    },
    async PDFExport(print = false) {
      const creator = this.creators.find(e => e.id === this.filter.person);
      return exportOfficialTablePdf({
        table: "#interpolaiton-report", title: "RELATÓRIO DE INTERPOLAÇÃO",
        details: [`Criador: ${creator?.name || "-"}`, `Produção total: ${this.computedTotalInterpolation || 0}`],
        filename: `relatorio_interpolacao_${Date.now()}.pdf`, print
      });
    },
    async PDFPrint() {
      await this.PDFExport(true);
    },
  },
  async mounted() {
    await this.actionGetCreators();
  }
}
</script>